import React from "react";

export type FieldQueryDefaultDataItem = any;

export type FieldQueryItem<DataItem = FieldQueryDefaultDataItem> = DataItem & {
  id: string | number;
};

export type FieldQueryInternalControl = {
  type?: FieldQueryPredefinedControlType;
  handler?: () => void;
  iconSrc?: string;
  description?: string;
  tooltip?: string;
  disabled?: boolean;
};

export type FieldQueryProps<T> = {
  className?: string;
  disabled?: boolean;
  items: FieldQueryItem<T>[];
  controls: Array<FieldQueryPredefinedControl<T>>;
  placeholder?: React.ReactNode;
  getId: {
    bodyRow: (params: { rowIndex: number }) => string;
    bodyRowCell: (params: { rowIndex: number; cellIndex: number }) => string;
    headerRow: string;
    headerRowCell: (params: { cellIndex: number }) => string;
  };
  columns: FieldQueryColumn[];
  classes?: {
    row?: string;
  };
  onRowDrop?: (dragIndex: number, hoverIndex: number) => void;
  enableDragDrop?: boolean;
};

export enum FieldQueryPredefinedControlType {
  moveUp = "moveUp",
  moveDown = "moveDown",
  removeAll = "removeAll",
}

export type FieldQueryPredefinedControl<DataItem = FieldQueryDefaultDataItem> = {
  type?: FieldQueryPredefinedControlType;
  handler?: (items: FieldQueryItem<DataItem>[]) => void;
  iconSrc?: string;
  description?: string;
  disabled?: boolean;
};

export type FieldQueryColumnComponentRenderParams<T = FieldQueryDefaultDataItem> = {
  row: FieldQueryItem<T>;
  columnIndex: number;
  rowIndex: number;
};

export type FieldQueryColumn = {
  label?: string;
  id: string | number;
  component: (params: FieldQueryColumnComponentRenderParams) => React.ReactNode;
};
